import React, { FC, useEffect, useState } from 'react';
import { Box } from '../../atoms/Box';
import type { IChangeableAndSubmittable, ILegoElemButton } from '../Lego/_Elem/models';
import { WizardHead } from './_Head/WizardHead';
import { Lego } from '../Lego';
import { ICurrentStep, IWizardStep } from './models';
import { IClassNameProps, ILoadingProps, IStylesProps } from '@src/models/props';
import { AnyType } from '@src/models/common';

export interface IWizardProps extends IClassNameProps, IStylesProps, ILoadingProps, IChangeableAndSubmittable {
  steps: IWizardStep[];
  legoValue?: AnyType;
  getCurrentStep?: (idx: number) => void;
}

export const Wizard: FC<IWizardProps> = ({ steps, onChange, onSubmit, legoValue, getCurrentStep }) => {
  const [currentStep, setCurrentStep] = useState<ICurrentStep | undefined>(undefined);
  const [, setValue] = useState<AnyType>({});

  const selectCurrentStep = (idx) => {
    getCurrentStep?.(idx + 1);
    if (idx < steps.length) {
      setCurrentStep({
        step: steps[idx],
        idx: idx,
        isLast: idx === steps.length - 1,
      });
    }
  };

  useEffect(() => {
    if (!currentStep) {
      selectCurrentStep(0);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentStep, steps]);

  const getStepElems = () => {
    if (currentStep?.step.elems) {
      const stdButton = {
        id: 'next',
        button: {
          size: 'lg',
          type: 'submit',
        },
        content: currentStep.isLast ? 'Отправить' : 'Продолжить',
      } as ILegoElemButton;

      if (currentStep?.step.endStepElems) {
        // Тут в дизайне захотели переопределеить кнопку перехода на следующий шаг или окончательной отправки
        // или/и добавить что-то после нее, но только на последнем шаге
        return [...currentStep?.step.elems, ...currentStep?.step.endStepElems];
      }

      return [...currentStep?.step.elems, stdButton];
    }
    return [];
  };

  const handleNext = (data: AnyType) => {
    if (!currentStep) {
      return;
    }

    if (onChange) {
      // заполнили шаг
      setValue((prev) => {
        return { ...prev, ...data };
      });
      onChange(data);
    }

    if (currentStep.isLast) {
      if (onSubmit) {
        // закончили заполнение всего визарда
        setValue((prev) => {
          const endValue = { ...prev, ...data };
          onSubmit(endValue);
          return endValue;
        });
      }
    } else {
      const nextStepIdx = currentStep.idx + 1;
      selectCurrentStep(nextStepIdx);
    }
  };

  return (
    <Box column>
      {currentStep && <WizardHead steps={steps} currentStep={currentStep} selectCurrentStep={selectCurrentStep} />}
      <Box marginTop={48}>
        <Lego
          onSubmit={handleNext}
          elems={getStepElems()}
          isNewForm={true}
          boxWrap={currentStep?.step.boxWrap}
          value={legoValue}
        />
      </Box>
    </Box>
  );
};
